class ParallaxBackground {
	constructor() {
		/** @type {Array<{element: HTMLElement, section: HTMLElement}>} */
		this.elements = [];
		/** @type {number|null} */
		this.rafId = null;
		this.init();
	}

	init() {
		// Clear existing elements
		this.elements = [];

		// Only enable parallax on desktop for performance
		if (window.innerWidth <= 749) {
			this.setupMobile();
			return;
		}

		this.setupParallaxElements();
		if (this.elements.length > 0) {
			this.bindScrollEvent();
			this.updateParallax(); // Initial update
		}
	}

	setupMobile() {
		/** @type {NodeListOf<HTMLElement>} */
		const elements = document.querySelectorAll(
			".background-image-fixed[data-bg-image]"
		);
		elements.forEach((element) => {
			const imageUrl = element.dataset.bgImage;
			if (imageUrl) {
				element.style.backgroundImage = `url(${imageUrl})`;
				element.style.transform = "none";
				element.setAttribute("data-parallax-active", "false");
			}
		});
	}

	setupParallaxElements() {
		/** @type {NodeListOf<HTMLElement>} */
		const elements = document.querySelectorAll(
			".background-image-fixed[data-bg-image]"
		);

		elements.forEach((element) => {
			const imageUrl = element.dataset.bgImage;
			if (imageUrl) {
				element.style.backgroundImage = `url(${imageUrl})`;
				element.setAttribute("data-parallax-active", "true");

				const section = /** @type {HTMLElement} */ (
					element.closest(".section")
				);
				if (section) {
					this.elements.push({
						element: element,
						section: section,
					});
				}
			}
		});
	}

	updateParallax() {
		this.elements.forEach(({ element, section }) => {
			const rect = section.getBoundingClientRect();
			const elementHeight = element.offsetHeight;
			const sectionHeight = section.offsetHeight;

			// Only calculate if section is visible
			if (rect.bottom >= 0 && rect.top <= window.innerHeight) {
				// Calculate parallax offset
				const scrollPercent =
					(window.innerHeight - rect.top) /
					(window.innerHeight + sectionHeight);
				const parallaxOffset =
					(elementHeight - sectionHeight) * scrollPercent * 0.5;

				// Apply transform
				element.style.transform = `translate3d(0, ${-parallaxOffset}px, 0)`;
			}
		});
	}

	bindScrollEvent() {
		const throttledUpdate = () => {
			if (this.rafId) return;

			this.rafId = requestAnimationFrame(() => {
				this.updateParallax();
				this.rafId = null;
			});
		};

		window.addEventListener("scroll", throttledUpdate, { passive: true });

		// Handle resize with debouncing
		/** @type {number|undefined} */
		let resizeTimeout;
		window.addEventListener(
			"resize",
			() => {
				if (resizeTimeout) {
					clearTimeout(resizeTimeout);
				}
				resizeTimeout = setTimeout(() => {
					this.init();
				}, 100);
			},
			{ passive: true }
		);
	}
}

// Global instance management
/** @type {ParallaxBackground|null} */
let parallaxInstance = null;

// Initialize when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
	if (!parallaxInstance) {
		parallaxInstance = new ParallaxBackground();
	}
});

// Also initialize when navigating between pages (for SPA-like behavior)
document.addEventListener("shopify:section:load", () => {
	if (parallaxInstance) {
		parallaxInstance.init();
	} else {
		parallaxInstance = new ParallaxBackground();
	}
});
